module.exports = __webpack_public_path__ + "media/images/4-empty-e3fd3a046f25a3bb56e4c77062a7bb21.png";